// extracted by mini-css-extract-plugin
export default {"wrapper":"live-search-preview_wrapper__N6sP+","mapContainer":"live-search-preview_mapContainer__YltEo","label":"live-search-preview_label__7Eena"};